import { render, staticRenderFns } from "./PostProfilesHandoverInfo.vue?vue&type=template&id=5504cbe6"
import script from "./PostProfilesHandoverInfo.vue?vue&type=script&lang=js"
export * from "./PostProfilesHandoverInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports